import { defineComponent as i, openBlock as o, createElementBlock as e, mergeProps as u, unref as l, renderSlot as g, createElementVNode as n, createCommentVNode as A } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const h = { key: 0 }, f = { key: 1 }, k = { key: 2 }, Z = { key: 3 }, w = { key: 4 }, y = { key: 5 }, M = {
  name: "ScalarIconGoogleLogo"
}, b = /* @__PURE__ */ i({
  ...M,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const a = s, { bind: d, weight: r } = m(a);
    return (p, t) => (o(), e("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, l(d)), [
      g(p.$slots, "default"),
      l(r) === "bold" ? (o(), e("g", h, t[0] || (t[0] = [
        n("path", { d: "M228,128a100,100,0,1,1-22.86-63.64,12,12,0,0,1-18.51,15.28A76,76,0,1,0,203.05,140H128a12,12,0,0,1,0-24h88A12,12,0,0,1,228,128Z" }, null, -1)
      ]))) : l(r) === "duotone" ? (o(), e("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M216,128a88,88,0,1,1-88-88A88,88,0,0,1,216,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M224,128a96,96,0,1,1-21.95-61.09,8,8,0,1,1-12.33,10.18A80,80,0,1,0,207.6,136H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : l(r) === "fill" ? (o(), e("g", k, t[2] || (t[2] = [
        n("path", { d: "M128,24A104,104,0,1,0,232,128,104,104,0,0,0,128,24Zm0,184A80,80,0,1,1,181.34,68.37a8,8,0,0,1-10.67,11.92A64,64,0,1,0,191.5,136H128a8,8,0,0,1,0-16h72a8,8,0,0,1,8,8A80.09,80.09,0,0,1,128,208Z" }, null, -1)
      ]))) : l(r) === "light" ? (o(), e("g", Z, t[3] || (t[3] = [
        n("path", { d: "M222,128a94,94,0,1,1-21.49-59.82,6,6,0,1,1-9.25,7.64A82,82,0,1,0,209.78,134H128a6,6,0,0,1,0-12h88A6,6,0,0,1,222,128Z" }, null, -1)
      ]))) : l(r) === "regular" ? (o(), e("g", w, t[4] || (t[4] = [
        n("path", { d: "M224,128a96,96,0,1,1-21.95-61.09,8,8,0,1,1-12.33,10.18A80,80,0,1,0,207.6,136H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128Z" }, null, -1)
      ]))) : l(r) === "thin" ? (o(), e("g", y, t[5] || (t[5] = [
        n("path", { d: "M220,128a92,92,0,1,1-21-58.55,4,4,0,0,1-6.17,5.1A84,84,0,1,0,211.91,132H128a4,4,0,0,1,0-8h88A4,4,0,0,1,220,128Z" }, null, -1)
      ]))) : A("", !0)
    ], 16));
  }
});
export {
  b as default
};
